import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-10 sm:py-20 px-4 bg-green-950/40 border-y border-green-700/20" data-id="element-108">
      <div className="max-w-3xl mx-auto text-center" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-20px'
      }} className="bg-green-950/60 p-8 sm:p-12 rounded-2xl sm:rounded-3xl shadow-xl border border-green-600/25" data-id="element-110">
          <div className="flex justify-center mb-6" data-id="element-111">
            <img src="https://cdn.magicpatterns.com/uploads/ejXAdAwGgvkK9kHYHqxx7M/jo3l6snt.png" alt="Garantía 7 días de reembolso" className="w-28 sm:w-36 h-auto drop-shadow-lg" width={144} height={144} loading="lazy" decoding="async" data-id="element-112" />
          </div>

          <h2 className="text-3xl sm:text-4xl font-black text-white mb-6 drop-shadow-lg uppercase" data-id="element-113">
            GARANTÍA DE SATISFACCIÓN TOTAL
          </h2>

          <div className="space-y-4 text-lg text-white/80 font-medium mb-8" data-id="element-114">
            <p className="text-xl font-bold text-yellow-300 uppercase" data-id="element-115">
              Probalo durante 7 días.
            </p>
            <p data-id="element-116">
              Si sentís que el Método Venta Flash IA no era lo que esperabas,
              podés pedir la devolución dentro de ese plazo.
            </p>
            <p className="font-bold" data-id="element-117">Sin vueltas.</p>
            <p data-id="element-118">
              Solo escribinos a:
              <br data-id="element-119" />
              <a href="mailto:soporteguiadigital360@gmail.com" className="text-yellow-300 font-bold hover:underline" data-id="element-120">
                soporteguiadigital360@gmail.com
              </a>
            </p>
          </div>

          <div className="inline-block bg-yellow-300/10 text-yellow-300 font-bold px-6 py-3 rounded-full border border-yellow-300/25 uppercase" data-id="element-121">
            Tu compra está protegida.
          </div>
        </motion.div>
      </div>
    </section>;
}